import { Check } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Todo } from '@/types/todo';

interface CompletedTodoItemProps {
  todo: Todo;
}

export default function CompletedTodoItem({ todo }: CompletedTodoItemProps) {
  const pointsEarned = todo.pointsEarned || 0;
  const completedTime = todo.completedAt ? new Date(todo.completedAt).toLocaleTimeString([], { 
    hour: '2-digit', 
    minute: '2-digit' 
  }) : '';
  
  return (
    <Card className="pt-4 pb-4 pl-6 pr-6 bg-muted/50">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-6 h-6 rounded-full bg-success flex items-center justify-center">
            <Check size={14} className="text-white" />
          </div>
          <div>
            <h3 className="font-medium text-foreground line-through opacity-75">
              {todo.title}
            </h3>
            <p className="text-sm text-muted-foreground">
              Completed at {completedTime}
            </p>
          </div>
        </div>
        
        <Badge 
          variant={pointsEarned >= 10 ? "default" : "secondary"}
          className={`${
            pointsEarned >= 10 
              ? 'bg-success text-white' 
              : 'bg-orange text-white'
          }`}
        >
          +{pointsEarned} pts
        </Badge>
      </div>
    </Card>
  );
}